import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  static get host(): string {
    return environment.api;
  }

  protected get signUpURL(): string {
    return UrlService.host + 'accounts';
  }

  protected get accountsCheckURL(): string {
    return UrlService.host + 'accounts/check/action';
  }

  protected get loginURL(): string {
    return UrlService.host + 'accounts/login';
  }

  protected get verifyOtpURL(): string {
    return UrlService.host + 'accounts/verify';
  }

  protected get verifyUpdateMobileOtpURL(): string {
    return UrlService.host + 'accounts/update-mobile';
  }
  protected get resendOtpURL(): string {
    return UrlService.host + 'accounts/resend-otp';
  }

  protected get categoriesURL(): string {
    return UrlService.host + 'categories?limit=5&page=0';
  }

  protected get categoriesMainURL(): string {
    return UrlService.host + 'main/categories';
  }

  protected get categoriesSetURL(): string {
    return UrlService.host + 'accounts/category/subcategory/details';
  }

  protected get categoriesDetailsURL(): string {
    return UrlService.host + 'accounts/details';
  }

  protected get categoriesAuthrizedDetailsURL(): string {
    return UrlService.host + 'accounts/authorized/details';
  }

  protected get whoAmiURL(): string {
    return (
      UrlService.host +
      'accounts?populates=accountsCategories.mainCategory.category.subCategory.accountCategorySubcategories'
    );
  }

  protected get forgotURL(): string {
    return UrlService.host + 'accounts/forgot-password';
  }

  protected get resetURL(): string {
    return UrlService.host + 'accounts/reset-password';
  }

  protected get subcategoriesURL(): string {
    return UrlService.host + 'form/categories/subcategories';
  }

  protected get criticalElementsURL(): string {
    return UrlService.host + 'critical-elements?limit=0&page=0&sort[name]=ASC';
  }

  protected get recyclerCriticalFormURL(): string {
    return UrlService.host + 'form/critical-recycler';
  }

  protected get recyclerCriticalOthersFormURL(): string {
    return UrlService.host + 'form/critical-recycler/others';
  }

  protected get details(): string {
    return UrlService.host + 'dashboard/category/details';
  }

  protected get recyclerFormURL(): string {
    return UrlService.host + 'form/nonferrous';
  }

  protected get tradersFormURL(): string {
    return UrlService.host + 'form/nonferrous';
  }

  protected get dismentelerFormURL(): string {
    return UrlService.host + 'form/nonferrous';
  }

  protected get agregatorFormURL(): string {
    return UrlService.host + 'form/nonferrous';
  }

  protected get collectiveCenterFormURL(): string {
    return UrlService.host + 'form/nonferrous';
  }

  protected get subCategoriesAssociateURL(): string {
    return UrlService.host + 'sub-categories?filters[isAssociate]=1';
  }

  protected get formAssociateURL(): string {
    return UrlService.host + 'form/associate';
  }

  protected get isriURL(): string {
    return UrlService.host + 'isri-values?limit=0';
  }

  protected get hsValuesURL(): string {
    return UrlService.host + 'hs-values?limit=0';
  }

  protected get preprocessValuesURL(): string {
    return UrlService.host + 'preprocess-values?limit=0';
  }

  protected get monitoringValuesURL(): string {
    return UrlService.host + 'monitoring/values?limit=0';
  }
  protected get pollutionValuesURL(): string {
    return UrlService.host + 'pollution/equipment?limit=0';
  }
  protected get gstURL(): string {
    return UrlService.host + 'gst/';
  }
  protected get panURL(): string {
    return UrlService.host + 'panverify/';
  }
  protected get verifiedCountURL(): string {
    return UrlService.host + 'admin/users/verified-count/';
  }
  protected get allUsersURL(): string {
    return UrlService.host + 'admin/account/details';
  }
  protected get deleteSemiPartials(): string {
    return UrlService.host + 'accounts/delete';
  }
  protected get allAppointRequest(): string {
    return UrlService.host + 'appointment/form/details';
  }
  protected get statusAppointRequest(): string {
    return UrlService.host + '/appointment/form/status';
  }
  protected get sendEmailUsersURL(): string {
    return UrlService.host + 'admin/user/sendemail';
  }
  protected get statusUserURL(): string {
    return UrlService.host + 'user/status';
  }
  protected get rejectionReasonURL(): string {
    return UrlService.host + 'admin/rejection-reason';
  }
  protected get rejectionUserReasonURL(): string {
    return UrlService.host + '/admin/user/reject-reasons/';
  }
  protected get wasteTypeURL(): string {
    return UrlService.host + 'categories?populates=subCategory';
  }

  protected get needSupportSubmissionURL(): string {
    return UrlService.host + 'support/form/submission';
  }

  protected get supportFormDetailsURL(): string {
    return UrlService.host + 'support/form/details';
  }

  protected get appointmentRequestURL(): string {
    return UrlService.host + 'appointment/form/submission';
  }

  protected get greenRatingFormURL(): string {
    return UrlService.host + 'green-rating/form/submission';
  }

  protected get greenRatingFormDetailsURL(): string {
    return UrlService.host + 'green-rating/form/details';
  }

  protected get approvalGreenRatingURL(): string {
    return UrlService.host + 'green-rating/form/status';
  }
  protected get getGreenRatingDetailsURL(): string {
    return UrlService.host + '/green-rating/form/details';
  }

  protected get adminIncentiveDetailsURL(): string {
    return UrlService.host + 'incentive/form/details';
  }

  protected get acceptRejectIncetiveURL(): string {
    return UrlService.host + 'incentive/form/status';
  }
  protected get incentiveEntityInformation(): string {
    return UrlService.host + 'incentive/form/submission';
  }
  protected get applyIncentiveDetails(): string {
    return UrlService.host + 'incentive/form/details';
  }
  protected get applyIncentivepayment(): string {
    return UrlService.host + 'payment';
  }
  protected get applyIndustryRatingDetails(): string {
    return UrlService.host + 'industry/form/details';
  }

  protected get updateIndustryRating(): string {
    return UrlService.host + 'industry/form/ratings';
  }

  protected get allIncentiveUsersURL(): string {
    return UrlService.host + 'incentive/form/details';
  }
  protected get IncentiveUsersLogsURL(): string {
    return UrlService.host + 'incentive/form/logs';
  }
  protected get uploadIndustryRating(): string {
    return UrlService.host + 'uploads';
  }
  protected get deleteUploadedIndustryRating(): string {
    return UrlService.host + 'uploads/delete';
  }
  protected get applyIndustryRating(): string {
    return UrlService.host + 'industry/form/submission';
  }
  protected get getIndustrytRating(): string {
    return (
      UrlService.host +
      'industry/form/details?populates=metalRecycled.metals&populates=ratings&populates=certification&populates=technologyUsed&populates=keyEquipmentAvailble&populates=wasteDisposalPractice'
    );
  }
  protected get downloadDocuments(): string {
    return UrlService.host + 'incentive/download-documents/';
  }

  protected get deleteIncetiveUser(): string {
    return UrlService.host + 'incentive/action';
  }
}
